import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6a1a4348&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6a1a4348&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a4348",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a1a4348')) {
      api.createRecord('6a1a4348', component.options)
    } else {
      api.reload('6a1a4348', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6a1a4348&scoped=true", function () {
      api.rerender('6a1a4348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/shopApply/index.vue"
export default component.exports